import type { ReactNode } from "react"

import { Calendar, Droplets, FlaskConical, Scissors } from "lucide-react"

import { cn } from "@/lib/utils"

export type CarePlanDeliverableKind = 'mower' | 'water' | 'fertilizer' | 'calendar'

export interface CarePlanDeliverable {
  kind: CarePlanDeliverableKind
  title: string
  value: string
}

interface CarePlanDeliverablesProps {
  items: CarePlanDeliverable[]
  className?: string
}

export function CarePlanDeliverables({ items, className }: CarePlanDeliverablesProps) {
  return (
    <div className={cn("grid grid-cols-2 gap-3", className)}>
      {items.map((item) => (
        <DeliverableTile key={item.kind} item={item} />
      ))}
    </div>
  )
}

const ICONS: Record<CarePlanDeliverableKind, ReactNode> = {
  mower: <Scissors className="h-[18px] w-[18px]" strokeWidth={2} />,
  water: <Droplets className="h-[18px] w-[18px]" strokeWidth={2} />,
  fertilizer: <FlaskConical className="h-[18px] w-[18px]" strokeWidth={2} />,
  calendar: <Calendar className="h-[18px] w-[18px]" strokeWidth={2} />,
}

function DeliverableTile({ item }: { item: CarePlanDeliverable }) {
  return (
    <div className="flex flex-col items-start gap-1.5 rounded-xl border border-green-100 bg-green-50/70 px-2.5 py-2.5 sm:flex-row sm:items-center sm:gap-3 sm:px-3.5 sm:py-3">
      <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg border border-green-100 bg-white text-green-700 sm:h-9 sm:w-9">
        {ICONS[item.kind]}
      </div>
      <div className="min-w-0 w-full">
        <div className="text-[9.5px] sm:text-[10.5px] font-semibold uppercase tracking-wider text-gray-500 leading-tight">
          {item.title}
        </div>
        <div className="text-[12px] sm:text-[15px] font-bold tracking-tight text-gray-900 leading-tight">
          {item.value}
        </div>
      </div>
    </div>
  )
}
